export default __webpack_public_path__ + "static/rip-4f74dda5263b8ce68d6be897f493ae87.svg";